module.exports = __webpack_public_path__ + "static/media/1WinterWhiteAQ5977.34af3882.PNG";